import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { usePathname } from 'src/routes/hooks';

import { roles } from 'src/utils/roles';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { PageTransition } from 'src/components/animate/page-transition';

import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const PaycardConfigPage = lazy(() => import('src/pages/paycard/config/list'));
const PaycardRapidCardsPage = lazy(() => import('src/pages/paycard/rapid-cards/list'));
const PaycardRapidConfigPage = lazy(() => import('src/pages/paycard/rapid-config/list'));
const PaycardRapidDisbursementConfigPage = lazy(() => import('src/pages/paycard/rapid-disbursement-config/list'));
const PaycardAkimboDistributorMap = lazy(() => import('src/pages/paycard/akimbo-distributor-map/list'));
const PaycardPaymentsPage = lazy(() => import('src/pages/paycard/payments/list'));
const PaycardEmployeesListPage = lazy(() => import('src/pages/paycard/employees/list'));
const PaycardEmployeesViewPage = lazy(() => import('src/pages/paycard/employees/view'));
const PaycardEmployeesEditPage = lazy(() => import('src/pages/paycard/employees/edit'));
const PaycardEmployeesNewPage = lazy(() => import('src/pages/paycard/employees/new'));

// ----------------------------------------------------------------------


const LayoutContent = () => {
  const pathname = usePathname();

  return (
    <DashboardLayout>
      <Suspense fallback={<LoadingScreen />} key={pathname}>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </Suspense>
    </DashboardLayout>
  )
};

export const paycardRoutes = [
  {
    path: 'paycard',
    element: CONFIG.auth.skip ? <LayoutContent /> : <AuthGuard><LayoutContent /></AuthGuard>,
    children: [
      { path: 'config', element: <RoleBasedGuard roles={[roles.ADMIN]} children={<PaycardConfigPage />} />, index: true },
      { path: 'rapid-cards', element: <RoleBasedGuard roles={[roles.PAYCARD_RAPID_ADMIN]} children={<PaycardRapidCardsPage />} /> },
      { path: 'rapid-config', element: <RoleBasedGuard roles={[roles.ADMIN]} children={<PaycardRapidConfigPage />} /> },
      { path: 'rapid-disbursement-config', element: <RoleBasedGuard roles={[roles.ADMIN]} children={<PaycardRapidDisbursementConfigPage />} /> },
      { path: 'akimbo-distributor-map', element: <RoleBasedGuard roles={[roles.ADMIN]} children={<PaycardAkimboDistributorMap />} /> },
      { path: 'payments', element: <RoleBasedGuard roles={[roles.PAYCARD_ADMIN]} children={<PaycardPaymentsPage />} /> },
      {
        path: 'employees', children: [
          { element: <RoleBasedGuard roles={[roles.PAYCARD_ADMIN]} children={<PaycardEmployeesListPage />} />, index: true },
          { path: ':id/view', element: <RoleBasedGuard roles={[roles.PAYCARD_ADMIN]} children={<PaycardEmployeesViewPage />} /> },
          { path: ':id/edit', element: <RoleBasedGuard roles={[roles.PAYCARD_ADMIN]} children={<PaycardEmployeesEditPage />} /> },
          { path: 'new', element: <RoleBasedGuard roles={[roles.PAYCARD_ADMIN]} children={<PaycardEmployeesNewPage />} /> },
        ]
      },
    ],
  },
];
